import GenericDB from './generic-db';
import ProgramsDB from './programs-db';

export default class ProgramFoldersDB extends GenericDB {
  constructor() {
    super('programFolders');
  }

  /**
   * Check if a folder is empty (does not contain programs or sub-folders)
   * @param {*} clinicId
   * @param {*} id
   */
  async isEmptyFolder(clinicId, id) {
    const programsDb = new ProgramsDB();
    const [programFoldersInFolder, programsInFolder] = await Promise.all(
      [
        this.readAll([['clinic', '==', clinicId], ['parentFolder', '==', id]]),
        programsDb.readAll([['clinic', '==', clinicId], ['parentFolder', '==', id], ['isDeleted', '==', false]]),
      ],
    );
    return programFoldersInFolder.length === 0 && programsInFolder.length === 0;
  }
}
